import { render } from "./AdminOrderItemEdit.vue?vue&type=template&id=dd2ef1da&scoped=true&ts=true&lang=true"
import script from "./AdminOrderItemEdit.vue?vue&type=script&lang=ts"
export * from "./AdminOrderItemEdit.vue?vue&type=script&lang=ts"

import "./AdminOrderItemEdit.vue?vue&type=style&index=0&id=dd2ef1da&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2ef1da"]])

export default __exports__